
import React, { useContext, useEffect, useState } from 'react'
import { Grid, Select, MenuItem, FormControl, InputLabel } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { Context } from '../../../Store'
import moment from 'moment'
import { ErrorMessage } from './ErrorMessage'
import { RENT_RETENTION_TYPE } from '../../../constants'

export const RentRentention = () => {
  const [state, dispatch] = useContext(Context)
  const [selectDisabled, setSelectDisabled] = useState(false)
  const [over12Months, setOver12Months] = useState(state?.over_12_months)
  const { t } = useTranslation()

  const { property } = state
  const { minStay = 1, maxStay, end_date: propertyEndDate } = property
  
  const durationValues = [
    {
      value: RENT_RETENTION_TYPE.UNDER,
      label: t('booking.checkIn.duration.under12Months'),
      disabled: false,
    },
    {
      value: RENT_RETENTION_TYPE.OVER,
      label: t('booking.checkIn.duration.over12Months'),
      disabled: maxStay && maxStay <= 12,
    },
  ]

  const onChangeOver18Months = (event) => {
    dispatch({ type: 'SET_OVER_12_MONTHS', payload: event.target.value })
    setOver12Months(event.target.value)
  }

  useEffect(() => {
    if (
          moment(propertyEndDate).subtract(minStay, 'months').isBefore(moment(state.start_date).add(12, 'months')) &&
          propertyEndDate
    ) {
      setSelectDisabled(true)
      setOver12Months(UNDER)
    }
      
    if (selectDisabled) {
      setSelectDisabled(false)

      if (moment(state.start_date).isValid() && (state.over_12_months || state.no_guest)) {
        setOver12Months(
          moment(state.end_date).diff(state.start_date, 'months', true) < 12 ? UNDER : OVER
        )
      }
    }
  }, [state.start_date])

  return (
    <Grid item xs={12} lg={11}>
      <FormControl fullWidth variant="outlined">
        <InputLabel>{t('booking.checkIn.duration.placeholder')}</InputLabel>
          <Select
            name="over_12_months"
            label={t('booking.checkIn.duration.placeholder')}
            value={over12Months}
            disabled={selectDisabled}
            onChange={onChangeOver18Months}
            error={state?.error?.over_12_months}
          >
            {durationValues.map((value) => (
              <MenuItem disabled={value.disabled} key={value.value} value={value.value}>
                {value.label}
              </MenuItem>
            ))}
          </Select>
      </FormControl>
      {state?.error?.over_12_months && <ErrorMessage error={state?.error?.over_12_months} />}
    </Grid>
  )
}